export const PUSH_MESSAGE = {
	COOKIE_NAME: "PushMessageNotification",
	COOKIE_VALUE: {
		DO_NOT_OPEN_POPUP: 1,
		OPEN_POPUP_NEXT_TIME: 2,
	},
	DIALOG_ID: "push-message-dialog",
	BLOCK: "block",
	ALLOW: "allow",
	TRANSLATION: {
		TITLE: "pushmessage.title",
		TEXT: "pushmessage.text",
		BLOCK: "pushmessage.block",
		ALLOW: "pushmessage.allow",
	},
};
